import { useTheme, DARK, LIGHT } from "./Layout";

interface Props {
  title: string;
  subtitle: string;
  icon: string;
  color: string;
  children?: React.ReactNode;
}

export default function PageWrapper({ title, subtitle, icon, color, children }: Props) {
  const { dark } = useTheme();
  const T = dark ? DARK : LIGHT;

  return (
    <div style={{ padding: "28px 28px 40px" }}>
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontSize: 11, color, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: 6 }}>
          {icon} {title}
        </div>
        <h1 style={{ fontSize: 26, fontWeight: 900, margin: 0, color: T.text }}>{title}</h1>
        <p style={{ fontSize: 13, color: T.subtext, margin: "5px 0 0" }}>{subtitle}</p>
      </div>

      <div style={{
        borderRadius: 18, padding: "60px 40px",
        background: dark ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.95)",
        border: `1px solid ${dark ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.07)"}`,
        backdropFilter: "blur(12px)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        textAlign: "center", minHeight: 300
      }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>{icon}</div>
        <div style={{ fontSize: 18, fontWeight: 700, color: T.text, marginBottom: 8 }}>صفحه {title}</div>
        <div style={{ fontSize: 13, color: T.subtext, maxWidth: 400 }}>
          این صفحه در حال توسعه است. به زودی قابلیت‌های کامل اضافه خواهد شد.
        </div>
        <div style={{ marginTop: 24, padding: "10px 24px", borderRadius: 10, background: `${color}18`, border: `1px solid ${color}30`, fontSize: 13, fontWeight: 600, color }}>
          {subtitle}
        </div>
      </div>

      {children}
    </div>
  );
}